import { createContext, useState, useMemo, useRef, useEffect, useContext } from 'react'

import { CompareItemsProps, CompareItemsLayout, CompareItemsLayoutMeasures } from '../types'
import { DEFAULT_ATTRIBUTE_COL_WIDTH, DEFAULT_ITEM_COL_WIDTH } from '../config/CompareItems_const'

export const LayoutContext = createContext<CompareItemsLayout>(null)

export default function useComponentLayout(): CompareItemsLayout {
  const layout = useContext(LayoutContext)
  return layout
}

export function useComponentLayoutState(props: CompareItemsProps): CompareItemsLayout {
  const [showComponent, setShowComponent] = useState<boolean>(props.showComponent)
  const [measures, setMeasures] = useState<CompareItemsLayoutMeasures>({})

  // sync managed states
  const lastProps = useRef<Partial<CompareItemsProps>>()
  if (null == lastProps.current) {
    lastProps.current = {
      showComponent: props.showComponent
    }
  }
  useEffect(() => {
    if (lastProps.current.showComponent !== props.showComponent) {
      lastProps.current.showComponent = props.showComponent
      setShowComponent(Boolean(props.showComponent))
    }
  }, [props.showComponent])

  const layout = useMemo(() => {
    return {
      showComponent,
      setShowComponent,
      attributeColWidth: null == props.attributeColWidth ? DEFAULT_ATTRIBUTE_COL_WIDTH : props.attributeColWidth,
      itemColWidth: null == props.itemColWidth ? DEFAULT_ITEM_COL_WIDTH : props.itemColWidth,
      measures,
      setMeasures: (newMeasures: CompareItemsLayoutMeasures) => {
        if (
          newMeasures?.attributeColFullWidth !== measures?.attributeColFullWidth ||
          newMeasures?.visualContentWidth !== measures?.visualContentWidth ||
          newMeasures?.dataVisualWidth !== measures?.dataVisualWidth ||
          newMeasures?.dataHeight !== measures?.dataHeight
        ) {
          setMeasures(newMeasures)
        }
      }
    }
  }, [showComponent, props.attributeColWidth, props.itemColWidth, measures])

  return layout
}
